import { ComplexValue } from 'app/types-shared';
import { FilterMenuValues, FilterValidation, FilterCommonValues } from './filters/types';
import { FilterCommonTypes, SearchFiltersConfig } from './types-store';
import { FilterValues } from './types';

export const ACTION = {
  UPDATE_SAVED_FILTERS_CONFIG: 'SEARCH_FILTERS:UPDATE_SAVED_FILTERS_CONFIG',

  UPDATE_FILTER_VALUES_TRANSLATION: 'SEARCH_FILTERS: UPDATE_FILTER_VALUES_TRANSLATION',
  UPDATE_FILTER_VALUES: 'SEARCH_FILTERS:UPDATE_FILTER_VALUES',
  UPDATE_FILTER_MENU_VALUES: 'SEARCH_FILTERS:UPDATE_FILTER_MENU_VALUES',
  UPDATE_FILTER_VALIDATION: 'SEARCH_FILTERS:UPDATE_FILTER_VALIDATION',
  CLEAR_ALL_FILTERS: 'SEARCH_FILTERS:CLEAR_ALL_FILTERS',
  OPEN_CLOSE_FILTER: 'SEARCH_FILTERS:OPEN_CLOSE_FILTER',

  UPDATE_QUERY: 'SEARCH_FILTERS:UPDATE_QUERY',
  UPDATE_QUERY_VALUE: 'SEARCH_FILTERS:UPDATE_QUERY_VALUE',
  UPDATE_QUERY_VALUES: 'SEARCH_FILTERS:UPDATE_QUERY_VALUES',
  CLEAR_QUERY: 'SEARCH_FILTERS:CLEAR_QUERY'
};

export class UpdateSavedFiltersConfig {
  public type: string = ACTION.UPDATE_SAVED_FILTERS_CONFIG;
  constructor(public filtersConfig: SearchFiltersConfig) {
  }
}

export class UpdateFilterValuesTranslation {
  public type: string = ACTION.UPDATE_FILTER_VALUES_TRANSLATION;
  constructor(public filterValues: FilterValues) {
  }
}

export class UpdateFilterValues {
  public type: string = ACTION.UPDATE_FILTER_VALUES;
  constructor(public id: string, public values: FilterCommonValues<FilterCommonTypes>[]) {
  }
}

export class UpdateFilterMenuValues {
  public type: string = ACTION.UPDATE_FILTER_MENU_VALUES;
  constructor(public id: string, public values: FilterMenuValues) {
  }
}

export class UpdateFilterValidation {
  public type: string = ACTION.UPDATE_FILTER_VALIDATION;
  constructor(public filterValidation: FilterValidation) {
  }
}

export class ClearAllFilters {
  public type: string = ACTION.CLEAR_ALL_FILTERS;
  constructor(public initialDefaultFilterValues: FilterValues) {
  }
}

export class OpenCloseFilter {
  public type: string = ACTION.OPEN_CLOSE_FILTER;
  constructor(public id: string, public open: boolean) {
  }
}

export class UpdateQuery {
  public type: string = ACTION.UPDATE_QUERY;
  constructor(public query: string) {
  }
}

export class UpdateQueryValue {
  public type: string = ACTION.UPDATE_QUERY_VALUE;
  constructor(public value: ComplexValue<number | string>) {
  }
}

export class SetQueryValues {
  public type: string = ACTION.UPDATE_QUERY_VALUES;
  constructor(public values: ComplexValue<number | string>[]) {
  }
}

export class ClearQuery {
  public type: string = ACTION.CLEAR_QUERY;
}
